import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { map, retry, catchError } from "rxjs/operators";

// import { environment } from '@environments/environment';
import { Utilizador, User, UserLic } from "@app/model";

const STORAGE_KEY: string = "userlic";

@Injectable({ providedIn: "root" })
export class AuthService {
  private userlicSubject: BehaviorSubject<UserLic>;
  private userlic: Observable<UserLic>;

  public utilizadorSubject: BehaviorSubject<Utilizador>;
  public utilizador: Observable<Utilizador>;


  baseUrl = "/apiat/auth";

  httpJSONHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
  httpJSONOptions = {
    headers: this.httpJSONHeaders
  }

  httpFormHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
  httpFormOptions = {
    headers: this.httpFormHeaders
  }

  constructor(private router: Router, private http: HttpClient) {
    this.userlicSubject = new BehaviorSubject<UserLic>(
      JSON.parse(localStorage.getItem(STORAGE_KEY))
    );
    this.userlic = this.userlicSubject.asObservable();

    this.utilizadorSubject = new BehaviorSubject<Utilizador>({} as Utilizador);
    this.utilizador = this.utilizadorSubject.asObservable();
  }

  public get userlicValue(): UserLic {
    if (this.userlicSubject == null) {
      return null;
    }
    return this.userlicSubject.value;
  }

  public get userValue(): User {
    if (this.userlicValue == null) {
      return null;
    }
    return this.userlicValue.user;
  }

  public get licitemsValue(): string[] {
    if (this.userlicValue == null) {
      return null;
    }
    return this.userlicValue.licItems;
  }


  // public get utilizadorValue(): Utilizador {
  //   console.info('utilizador', this.utilizadorSubject.value);
  //   return this.userSubject.value.utilizador;
  // }

  isAdmin() {
    return this.userValue.roles.includes('ADMIN');
  }

  isAdminRH() {
    return this.userValue.roles.includes('ADMIN_RH');
  }

  login(username, password) {
    console.log("auth.login", username);

    const u = {
      username: username,
      password: password
    } as User;

    return this.http
      .post<UserLic>(this.baseUrl + "/login", JSON.stringify(u), this.httpJSONOptions)
      .pipe(map(userlic => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
          console.log('http.return', userlic);
          localStorage.setItem(STORAGE_KEY, JSON.stringify(userlic));
          this.userlicSubject.next(userlic);
          console.log('http.return.utilizador', userlic.user.username);

          return userlic.user;
          // this.utilizadorSubject.next(user.username);
        })
      );
      //   map((token) => {
      //     // store user details and jwt token in local storage to keep user logged in between page refreshes
      //     console.log('token', token);
      //     var user = {
      //       username: username,
      //       token: token
      //     } as User;
      //     console.log('user', user);
      //     localStorage.setItem("user", JSON.stringify(user));
      //     this.userSubject.next(user);
      //     return user;
      //   }),
      //   catchError(this.handleError)
      // );
  }

  loginform(username, password) {
    console.log("auth.loginform", username);

    const body = new HttpParams()
      .set('username', username)
      .set('password', password);

    return this.http
      //.post<User>(this.baseUrl + "/login", JSON.stringify(u), this.httpOptions)
      .post<UserLic>(this.baseUrl + "/loginform", body, this.httpFormOptions)
      .pipe(map(userlic => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
          console.log('http.return', userlic);
          localStorage.setItem(STORAGE_KEY, JSON.stringify(userlic));
          this.userlicSubject.next(userlic);
          // console.log('http.return.utilizador', user);
          // this.utilizadorSubject.next(user.utilizador);
          return userlic.user;
        })
      );
      //   map((token) => {
      //     // store user details and jwt token in local storage to keep user logged in between page refreshes
      //     console.log('token', token);
      //     var user = {
      //       username: username,
      //       token: token
      //     } as User;
      //     console.log('user', user);
      //     localStorage.setItem("user", JSON.stringify(user));
      //     this.userSubject.next(user);
      //     return user;
      //   }),
      //   catchError(this.handleError)
      // );
  }

  // whoami() {
  //   console.log("auth.whoami");
  //   return this.http.post<Utilizador>(this.baseUrl + "/whoami", {}).pipe(
  //     map((utilizador) => {
  //       // store user details and jwt token in local storage to keep user logged in between page refreshes
  //       console.info('whoami.utilizador', utilizador);
  //       this.utilizadorSubject.next(utilizador);
  //       return utilizador;
  //     })
  //   );
  // }

  logout() {
    console.log("auth.logout");
    // remove user from local storage and set current user to null
    localStorage.removeItem(STORAGE_KEY);
    this.userlicSubject.next(null);
    this.utilizadorSubject.next(null);

    // this.http
    //   .post(this.baseUrl + "/logout", {})
    //   .pipe(retry(2), catchError(this.handleError));

    this.router.navigate(["/"]);
  }

  register(utilizador: Utilizador) {
    console.log("auth.register", utilizador);
    return this.http.post(this.baseUrl + "/register", JSON.stringify(utilizador), this.httpJSONOptions);
  }

  // getAll() {
  //     return this.http.get<User[]>(`${environment.apiUrl}/users`);
  // }

  // getById(id: string) {
  //     return this.http.get<User>(`${environment.apiUrl}/users/${id}`);
  // }

  // update(id, params) {
  //     return this.http.put(`${environment.apiUrl}/users/${id}`, params)
  //         .pipe(map(x => {
  //             // update stored user if the logged in user updated their own record
  //             if (id == this.userValue.id) {
  //                 // update local storage
  //                 const user = { ...this.userValue, ...params };
  //                 localStorage.setItem('user', JSON.stringify(user));

  //                 // publish updated user to subscribers
  //                 this.userSubject.next(user);
  //             }
  //             return x;
  //         }));
  // }

  // delete(id: string) {
  //     return this.http.delete(`${environment.apiUrl}/users/${id}`)
  //         .pipe(map(x => {
  //             // auto logout if the logged in user deleted their own record
  //             if (id == this.userValue.id) {
  //                 this.logout();
  //             }
  //             return x;
  //         }));
  // }

  // Manipulação de erros
  //O angular recomenda que métodos de manipulação de erros devem ser nos serviços e não nos componentes.
  handleError(error: HttpErrorResponse) {
    let errorMessage = "";
    //console.log(error);
    //console.log(error.error);
    //console.log(error.error.typeof());
    if (typeof error.error == "string") {
      errorMessage = error.error;
    } else if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage =
        `Código do erro: ${error.status}, ` + `mensagem: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
